<template>
  <CModal
    v-model:visible="showModal"
    title="Change Password"
    color="primary"
    :close-on-backdrop="false"
  >
    <form
      autocomplete="off"
      @submit.prevent="submit"
    >
      <CInput
        v-model="password_data.old_password"
        label="Current Password"
        :type="showOld ? 'text' : 'password'"
        autocomplete="current-password"
        :add-input-classes="{ 'is-invalid': hasError('old_password') }"
        :invalid-feedback="getError('old_password')"
      >
        <template #append>
          <div
            class="input-group-text toggle-password"
            @click="showOld = !showOld"
          >
            <i :class="showOld ? 'fas fa-eye-slash' : 'fas fa-eye'" />
          </div>
        </template>
      </CInput>

      <CInput
        v-model="password_data.password"
        label="New Password"
        :type="showNew ? 'text' : 'password'"
        autocomplete="new-password"
        :add-input-classes="{ 'is-invalid': hasError('password') }"
        :invalid-feedback="getError('password')"
      >
        <template #append>
          <div
            class="input-group-text toggle-password"
            @click="showNew = !showNew"
          >
            <i :class="showNew ? 'fas fa-eye-slash' : 'fas fa-eye'" />
          </div>
        </template>
      </CInput>

      <CInput
        v-model="password_data.password_confirmation"
        label="Confirm New Password"
        :type="showConfirm ? 'text' : 'password'"
        autocomplete="new-password"
        :add-input-classes="{ 'is-invalid': hasError('password_confirmation') }"
        :invalid-feedback="getError('password_confirmation')"
      >
        <template #append>
          <div
            class="input-group-text toggle-password"
            @click="showConfirm = !showConfirm"
          >
            <i :class="showConfirm ? 'fas fa-eye-slash' : 'fas fa-eye'" />
          </div>
        </template>
      </CInput>
    </form>

    <template #footer>
      <CButton
        color="secondary"
        @click="close"
      >
        Cancel
      </CButton>
      <CButton
        color="primary"
        :disabled="loading"
        @click="submit"
      >
        <CSpinner
          v-if="loading"
          size="sm"
          class="mr-1"
        />
        Update Password
      </CButton>
    </template>
  </CModal>
</template>

<script>
import hasApiValidation from '@/mixins/hasApiValidation';

export default {
  name: 'ChangePasswordModal',
  mixins: [hasApiValidation],
  data() {
    return {
      showModal: false,
      loading: false,
      submitUrl: '',
      showOld: false,
      showNew: false,
      showConfirm: false,

      password_data: {
        old_password: '',
        password: '',
        password_confirmation: '',
      },
    };
  },
  methods: {
    open(url) {
      this.setErrors({});
      this.submitUrl = url;

      this.password_data = { old_password: '', password: '', password_confirmation: '' };
      this.showOld = false;
      this.showNew = false;
      this.showConfirm = false;

      this.showModal = true;
    },
    close() {
      this.showModal = false;
      this.setErrors({});
    },
    submit() {
      this.setErrors({});
      this.loading = true;

      this.$http
        .put(this.submitUrl, this.password_data)
        .then(() => {
          this.$toast.success('Password changed successfully');
          this.close();
        })
        .catch(({ response }) => {
          this.$toast.error(response.data.message || 'Error updating password');
          this.setErrors(response.data.errors);
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>

<style scoped>
.toggle-password {
  cursor: pointer;
  background-color: #ffffff;
  color: #6c757d;
  transition: color 0.2s ease;
}

.toggle-password:hover {
  color: var(--primary);
}
</style>
